module.exports = {"title":"Užívateľský účet","button.close":"Zatvoriť"}